import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import assetPath from '@uikit/helpers/assetPath';
import { Asset } from '@uikit/types';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import type { BreakpointAspectRatioConfigs } from '../LegacyPicture/image-transformer/types';
import styles from './MagazineHeroArea.module.scss';
import type { MagazineHeroAreaProps } from './interfaces';

const FALLBACK_IMAGE: Asset = {
  name: 'Enercity Magazin Bild',
  path: assetPath + '/assets/magazine/magazine-fallback-image.png',
};

const breakpointAspectRatioConfigs: BreakpointAspectRatioConfigs = [
  {
    breakpoint: BreakPoint.XSS,
    aspectRatio: '4:3',
  },
  {
    breakpoint: BreakPoint.XS,
    aspectRatio: '4:3',
  },
  {
    breakpoint: BreakPoint.SM,
    aspectRatio: '4:3',
  },
  {
    breakpoint: BreakPoint.MD,
    aspectRatio: '16:9',
  },
  {
    breakpoint: BreakPoint.LG,
    aspectRatio: '21:9',
  },
  {
    breakpoint: BreakPoint.XL,
    aspectRatio: '21:9',
  },
];

const MagazineHeroArea = ({
  image = FALLBACK_IMAGE,
  logo,
  shadow,
  children,
}: MagazineHeroAreaProps) => {
  return (
    <div className={styles.base}>
      <LegacyPicture
        asset={image}
        className={styles.picture}
        fitCover
        breakpointAspectRatioConfigs={breakpointAspectRatioConfigs}
      />
      <div className={styles.content}>
        {logo}
        <div className={styles.elements}>{children}</div>
      </div>
      {shadow}
    </div>
  );
};

export default MagazineHeroArea;
